import { DataShareService } from 'src/app/shared/services/DataShareService.service';
import { OktaService } from 'src/app/shared/services/okta.service';
import { Component, OnInit } from '@angular/core';
import { constants } from '../../constants/constants';
import { FileService } from '../../services/file.service';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {
  currentYear: any = '';
  CopyRightText: string = '';
  contact: any;
  email: any;
  CopyMesg: string = '';
  Copied: boolean = false;
  TermsPrivacy: any;
  SessionTimeOut: boolean = false;
  SessionAndUnauthorizedMessage: string = '';
  UserLoggedIn: boolean = false;
  ReleaseNotes: any;
  ReleaseNoteUrl: any;
  constructor(
    private oktaservice: OktaService,
    private DataShareService: DataShareService,
    private fileService: FileService
  ) {
    this.DataShareService.setUserLogIn$.subscribe(UserLoggedIn => {
      this.UserLoggedIn = UserLoggedIn;
    });
    this.DataShareService.FooterComponentUnauthorized$.subscribe(res => {
      this.UnauthorizedPopup(res);
    });
  }
  ngOnInit() {
    this.GetApplicationSettings();
    this.CopyMesg = constants.copy;
    this.CopyRightText = constants.CopyRightText;
  }
  GetApplicationSettings() {
    var data: any[] = JSON.parse(
      localStorage.getItem(constants.ApplicationSettings)
    );
    if (data == null && this.UserLoggedIn == true) {
      this.email = '';
      this.contact = '';
      this.SessionTimeOut = true;
      this.SessionAndUnauthorizedMessage = constants.SessionExpiredMessage;
    } else if (data != null) {
      this.SessionAndUnauthorizedMessage = '';
      var obj = data.filter((obj: any) => obj.key === constants.ContactNumber);
      this.contact = String(obj[0].value);

      var obj = data.filter((obj: any) => obj.key === constants.EmailID);
      this.email = String(obj[0].value);

      this.TermsPrivacy = data.filter(
        (obj: any) => obj.key === constants.TermsPrivacy
      )[0].value;

      this.ReleaseNotes = data.filter(
        (obj: any) => obj.key === 'ReleaseNotes'
      )[0].value;
    }
  }
  DownloadUserManual() {
    let type: string = 'application/pdf';
    let download: any = {
      FileName: 'Download_User_Guide',
    };
    this.fileService.DownloadUserGuide(download, type);
  }
  OnSessionTimeOut() {
    this.SessionAndUnauthorizedMessage = '';
    this.SessionTimeOut = false;
    this.oktaservice.logout();
  }
  CopyData(val: string) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    if (val == this.contact) {
      document.getElementById('ContactTooltip').style.display = 'inline';
      setTimeout(function () {
        document.getElementById('ContactTooltip').style.display = 'none';
      }, 1000);
    } else {
      document.getElementById('EmailTooltip').style.display = 'inline';
      setTimeout(function () {
        document.getElementById('EmailTooltip').style.display = 'none';
      }, 1000);
    }
  }
  UnauthorizedPopup(flag: any) {
    if (flag) {
      this.SessionAndUnauthorizedMessage = constants.UnauthorizedMessage;
      this.SessionTimeOut = true;
    } else {
      this.SessionAndUnauthorizedMessage = '';
      this.SessionTimeOut = false;
    }
  }
  ReleaseNote() {
    this.GetApplicationSettings();
    this.ReleaseNoteUrl = URL.createObjectURL(
      new Blob([this.ReleaseNotes], { type: 'text/html' })
    );
    window.open(this.ReleaseNoteUrl);
  }
}
